import React from "react";
import { Box, Typography } from "@mui/material";
import { HINDI_FONT } from "../Temples/shared";
import { Images } from "../../utils/Images";
import lotusDivider from "../../assets/Images/TempleDetail/lotus-divider.svg";

// Temple campaign detail page — Figma "Website Revamp", node 3408:13879.
// Maroon + temple gold on warm sand, the same family as the /temples page.
export const T = {
  red: "#EC1B26",
  coral: "#F04951",
  ink: "#1D1D1B",
  body: "#4A4542",
  bodyWarm: "#3F3A36",
  muted: "#7D7D7D",
  gold: "#C9952B",
  goldLight: "#E9B95A",
  sand: "#EFE4D3",
  cream: "#FBF5EC",
  maroon: "#2A0A0C",
};
export const FONT = "Red Hat Display";
export { HINDI_FONT };

// White section card used down the left column.
export const SectionCard = ({ children, sx, id, component = "section" }) => (
  <Box
    component={component}
    id={id}
    sx={{
      position: "relative",
      background: "#FFFFFF",
      border: "0.5px solid rgba(201,149,43,0.3)",
      borderRadius: { xs: "20px", sm: "28px" },
      boxShadow: "0px 10px 30px 0px rgba(89,38,13,0.06)",
      p: { xs: "20px", sm: "32px" },
      overflow: "hidden",
      scrollMarginTop: "120px",
      ...sx,
    }}
  >
    {children}
  </Box>
);

// "READ THE HISTORY ॥ इतिहास ॥" eyebrow + title + lotus rule.
export const SectionHeading = ({ eyebrow, hindi, title, size = 28, id }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "6px", alignItems: "flex-start", minWidth: 0 }}>
    <Box sx={{ display: "flex", gap: "6px", alignItems: "center", color: T.gold, flexWrap: "wrap" }}>
      <Typography sx={{ fontFamily: FONT, fontWeight: 700, fontSize: "11px", lineHeight: "14px", letterSpacing: "1.32px", textTransform: "uppercase", color: T.gold }}>
        {eyebrow}
      </Typography>
      {hindi && (
        <Typography sx={{ fontFamily: HINDI_FONT, fontSize: "16px", lineHeight: "22px", color: T.gold }}>{hindi}</Typography>
      )}
    </Box>
    <Typography
      component="h2"
      id={id}
      sx={{
        fontFamily: FONT,
        fontWeight: 700,
        fontSize: { xs: size === 28 ? "22px" : "20px", sm: `${size}px` },
        lineHeight: { xs: 1.3, sm: size === 28 ? "36px" : "32px" },
        color: T.ink,
      }}
    >
      {title}
    </Typography>
    <Box component="img" src={lotusDivider} alt="" sx={{ width: "140px", height: "14px", display: "block" }} />
  </Box>
);

export const inr = (n) => `₹${Math.round(Number(n) || 0).toLocaleString("en-IN")}`;

// The design sets ₹ in Inter (Red Hat Display's ₹ glyph differs).
export const Rupee = ({ value }) => (
  <>
    <Box component="span" sx={{ fontFamily: "Inter, sans-serif" }}>₹</Box>
    {Math.round(Number(value) || 0).toLocaleString("en-IN")}
  </>
);

// Campaign photo: swaps to the site's fallback image if the file can't be loaded.
export const Photo = ({ src, sx, ...rest }) => (
  <Box
    component="img"
    src={src || Images.fallBackImageCard}
    alt=""
    onError={(e) => {
      if (e.currentTarget.dataset.fallback) return;
      e.currentTarget.dataset.fallback = "1";
      e.currentTarget.src = Images.fallBackImageCard;
    }}
    sx={sx}
    {...rest}
  />
);

// Photo scaled to fill the frame (cover, centred) — no blurred side bands. Used by the history
// card and the story cards. Fills its parent, which must be position: relative/absolute.
export const FitPhoto = ({ src }) => (
  <Box sx={{ position: "absolute", inset: 0, overflow: "hidden" }}>
    <Photo src={src} sx={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" }} />
  </Box>
);
